export const deckConstants = {
  ADD_DECK_REQUEST: "ADD_DECK_REQUEST1",
  ADD_DECK_SUCCESS: "ADD_DECK_SUCCESS1",
  ADD_DECK_FAILURE: "ADD_DECK_FAILURE1",

  GET_DECK_REQUEST: "GET_DECK_REQUEST1",
  GET_DECK_SUCCESS: "GET_DECK_SUCCESS1",
  GET_DECK_FAILURE: "GET_DECK_FAILURE1",

  DELETE_DECK_REQUEST: "DELETE_DECK_REQUEST1",
  DELETE_DECK_SUCCESS: "DELETE_DECK_SUCCESS1",
  DELETE_DECK_FAILURE: "DELETE_DECK_FAILURE1",

  GET_ALL_DECKS_REQUEST: "GET_ALL_DECKS_REQUEST1",
  GET_ALL_DECKS_SUCCESS: "GET_ALL_DECKS_SUCCESS1",
  GET_ALL_DECKS_FAILURE: "GET_ALL_DECKS_FAILURE1",

  CHANGE_DECK_NAME_REQUEST: "CHANGE_DECK_NAME_REQUEST1",
  CHANGE_DECK_NAME_SUCCESS: "CHANGE_DECK_NAME_SUCCESS1",
  CHANGE_DECK_NAME_FAILURE: "CHANGE_DECK_NAME_FAILURE1",

  CHANGE_DECK_CODE_REQUEST: "CHANGE_DECK_CODE_REQUEST1",
  CHANGE_DECK_CODE_SUCCESS: "CHANGE_DECK_CODE_SUCCESS1",
  CHANGE_DECK_CODE_FAILURE: "CHANGE_DECK_CODE_FAILURE1",

  CHANGE_DECK_NODE_REQUEST: "CHANGE_DECK_NODE_REQUEST1",
  CHANGE_DECK_NODE_SUCCESS: "CHANGE_DECK_NODE_SUCCESS1",
  CHANGE_DECK_NODE_FAILURE: "CHANGE_DECK_NODE_FAILURE1",

  CHANGE_DECK_TAGS_REQUEST: "CHANGE_DECK_TAGS_REQUEST1",
  CHANGE_DECK_TAGS_SUCCESS: "CHANGE_DECK_TAGS_SUCCESS1",
  CHANGE_DECK_TAGS_FAILURE: "CHANGE_DECK_TAGS_FAILURE1",

  GET_DECK_CARDS_REQUEST: "GET_DECK_CARDS_REQUEST1",
  GET_DECK_CARDS_SUCCESS: "GET_DECK_CARDS_SUCCESS1",
  GET_DECK_CARDS_FAILURE: "GET_DECK_CARDS_FAILURE1",

  DELETE_DECK_CARDS_REQUEST: "DELETE_DECK_CARDS_REQUEST1",
  DELETE_DECK_CARDS_SUCCESS: "DELETE_DECK_CARDS_SUCCESS1",
  DELETE_DECK_CARDS_FAILURE: "DELETE_DECK_CARDS_FAILURE1",

  UPDATE_CARDS_INDEX_REQUEST: "UPDATE_CARDS_INDEX_REQUEST1",
  UPDATE_CARDS_INDEX_SUCCESS: "UPDATE_CARDS_INDEX_SUCCESS1",
  UPDATE_CARDS_INDEX_FAILURE: "UPDATE_CARDS_INDEX_FAILURE1",

  ADD_DECK_CARDS_REQUEST: "ADD_DECK_CARDS_REQUEST1",
  ADD_DECK_CARDS_SUCCESS: "ADD_DECK_CARDS_SUCCESS1",
  ADD_DECK_CARDS_FAILURE: "ADD_DECK_CARDS_FAILURE1",

  EDIT_DECK_CARDS_REQUEST: "EDIT_DECK_CARDS_REQUEST1",
  EDIT_DECK_CARDS_SUCCESS: "EDIT_DECK_CARDS_SUCCESS1",
  EDIT_DECK_CARDS_FAILURE: "EDIT_DECK_CARDS_FAILURE1",

  UPDATE_CARDS_IN_DECK_REQUEST: "UPDATE_CARDS_IN_DECK_REQUEST1",
  UPDATE_CARDS_IN_DECK_SUCCESS: "UPDATE_CARDS_IN_DECK_SUCCESS1",
  UPDATE_CARDS_IN_DECK_FAILURE: "UPDATE_CARDS_IN_DECK_FAILURE1"
}
